import type { ContentSnapshotV2 } from "../../runtime/content/ContentSnapshotV2";
import { DraftUiContentAdapter } from "../screens/DraftUiContentAdapter";

export type EditorPreviewTarget = {
  id: string;
  screenKey: string;
  label: string;
};

export const EDITOR_PREVIEW_TARGETS: readonly EditorPreviewTarget[] = [
  { id: "home", screenKey: "screen_home", label: "Home" },
  { id: "castle", screenKey: "screen_castle", label: "Castle" },
  { id: "missions", screenKey: "screen_mission_board", label: "Mission Board" },
  { id: "black-keep", screenKey: "screen_black_keep", label: "Black Keep" },
  { id: "expeditions", screenKey: "screen_expedition_board", label: "Expedition Board" },
  { id: "world-hunts", screenKey: "screen_pvp_neighbourhood_map", label: "World Hunts" },
  { id: "kingdom-threat", screenKey: "screen_pvp_neighbourhood_map", label: "Kingdom Threat" },
  { id: "knights", screenKey: "screen_knights_roster", label: "Knights" },
  { id: "pvp", screenKey: "screen_pvp_neighbourhood_map", label: "PvP" },
] as const;

const routeTargets: Array<[RegExp, string]> = [
  [/^\/missions/, "screen_mission_board"],
  [/^\/black-keep/, "screen_black_keep"],
  [/^\/expeditions/, "screen_expedition_board"],
  [/^\/(world-hunts|kingdom-threats)/, "screen_pvp_neighbourhood_map"],
  [/^\/(neighbourhood|pvp)/, "screen_pvp_neighbourhood_map"],
  [/^\/core/, "screen_castle"],
];

export function previewScreenForRoute(pathname: string) {
  if (pathname.startsWith("/screens") && pathname.includes("kind=template")) return "template_knight_detail";
  return routeTargets.find(([pattern]) => pattern.test(pathname))?.[1] ?? "screen_home";
}

type CacheEntry = { snapshot: ContentSnapshotV2; loadedAt: number };
const cache = new Map<string, CacheEntry>();
const CACHE_MILLISECONDS = 15_000;

export async function assembleDraftPreview(screenKey: string, force = false): Promise<ContentSnapshotV2> {
  const existing = cache.get(screenKey);
  if (!force && existing && Date.now() - existing.loadedAt < CACHE_MILLISECONDS) return existing.snapshot;
  const adapter = await new DraftUiContentAdapter().loadDocumentByKey(screenKey);
  cache.set(screenKey, { snapshot: adapter.snapshot, loadedAt: Date.now() });
  return adapter.snapshot;
}

export function invalidateDraftPreview(screenKey?: string) {
  if (screenKey) cache.delete(screenKey);
  else cache.clear();
}
